export function notification_list(state = [], action) {
  if (action.type === 'GET_NOTIFICATION_LIST') {
    return action.notification_list;
  }

  return state;
}
